import './index.css'
import NavBar from './nav_bar';
import Project from './Project';
import Footer from "./Footer";
function AllProjects(){
    return(
        <div>
            <NavBar/>
            <Project/>
            <Footer />
        </div>
    )
    };
    export default AllProjects;